import { IToastDetails } from "./interfaces";
import { IToastsState } from "./reducer";

export interface IWithToastsState {
  features: {
    toast: IToastsState;
  };
}

export function getToasts(state: IWithToastsState): { [key: string]: IToastDetails } {
  return state.features.toast.items;
}
